import React, { useEffect } from 'react';
import Footer from '../../Shared/Footer/Footer';
import Menubar from '../../Shared/Menubar/Menubar';
import Headers from '../Headers/Headers';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Home.module.css'
import GetInTouch from '../GetInTouch/GetInTouch';
import HomeBlogs from '../HomeBlogs/HomeBlogs';
import Skills from '../../Skills/Skills';
import HomeProjects from '../HomeProjects/HomeProjects';




const Home = () => {
    
   
    return (
        <div className={styles.body}>
            <div className="row">
                <div className="col-md-1">
                    <Sidebar/>
                </div>
                <div className="col-md-10">
                    <Menubar></Menubar>
                    <Headers/>
                    <Skills/>
                    <HomeProjects/>
                    <HomeBlogs/>
                    <GetInTouch/>
                    <Footer/>
                </div>
                <div className="col-md-1">

                </div>
            </div>
        </div>
    );
};

export default Home;